<script lang="ts">
	import { formatNumberWithSeparators } from '../../../../functions';
	import SedeTipologiaLavoratore from '../../../../models/Sede/SedeTipologiaLavoratore';

    export let data: SedeTipologiaLavoratore[] = [];
</script>

<table class="w-full text-xs border border-black table-fixed">
    <thead>
        <tr>
        <th class="border border-black">Voce</th>
        <th class="border border-black">Valore</th>
        </tr>
    </thead>
    <tbody>
        {#each data as sedeTipologiaLavoratore}
            <tr>
                <td class="text-center border border-black">{sedeTipologiaLavoratore?.tipologiaLavoratore?.nome || '-'}</td>
                <td class="text-center border border-black">{formatNumberWithSeparators(sedeTipologiaLavoratore?.percentuale) + '%' || '-'}</td>
            </tr>
        {/each}
    </tbody>
</table>
